import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-sprite-svg/ui-sprite-svg';
import iconStyle from './ui-header-icon-back.css?inline';

const CName = 'ui-header-icon-back';

@customElement(CName)
export class UIHeaderIconBack extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    return html`<ui-sprite-svg class="icon" .iconID=${'header-icon-back'}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIHeaderIconBack;
  }
}
